import React, { useState, useEffect, useRef } from "react";
import awardImage from "assests/awards.png";
import Container from "Components/Container/Container";
import "./style.css";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
const About = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="scroll-section h-[100vh] relative py-primary overflow-hidden"
    >
      <div
        className={`absolute left-0 top-0 w-full h-full z-[0] transition-opacotu ease-in duration-1000  zoom ${
          visible ? "zoomed opacity-100" : "opacity-0"
        }`}
      >
        <img
          className="w-full h-full object-cover lg:hidden"
          src={data?.image}
          alt=""
        />
        <img className="w-full hidden lg:block" src={data?.image} alt="" />
      </div>
      <Container className="h-full relative">
        <div className="flex flex-col justify-center gap-y-10 h-full">
          {/* About Us Section */}
          <div
            className={`lg:w-1/2 lg:ml-auto lg:mr-[12rem] transition-transform duration-500 ${
              visible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-[-200px]"
            }`}
          >
            <h2 className="title uppercase">{data?.title}</h2>
            <p className="text-white text-xl  mt-2 mb-6">{data?.sub_title}</p>
            <Link
              to={"/company-profile"}
              className="border border-[#d6d6d6] px-6 py-2 lg:px-8 lg:py-3 text-white w-max transition ease-in duration-300 hover:bg-font hover:text-black "
            >
              Discover more
            </Link>
          </div>

          {/* Awards Section */}
          <Link
            to={"/awards-and-certification"}
            className="group   w-max flex items-center lg:justify-end ml-auto lg:mr-24 "
          >
            <p
              className={`text-5xl  relative z-[10] font-medium text-white group-hover:text-font transition-all duration-500 ease-out flex items-center ${
                visible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-[-200px]"
              }`}
            >
              Awards and <br /> Certificates
              <span className="transition ease-in duration-300 translate-x-[-20%] group-hover:translate-x-[0] opacity-0 group-hover:opacity-100 text-4xl">
                <CaretRight />
              </span>
            </p>
            <img
              className={`-ml-28 group-hover:scale-[1.06]   w-[20rem] lg:w-[24rem] transition-transform duration-500 ${
                visible ? "scale-100" : "scale-[0.2]"
              }`}
              src={awardImage}
              alt="Awards"
            />
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default About;
